/**
 * The one CSV cell escaper on the frontend — a port of the backend's
 * `backend/src/helpers/csvCell.js` (design guardrail 16, B-402).
 *
 * Some exports are built in the browser rather than by a route (the symptom
 * log, the admin user list). Those were writing their own four plausible lines
 * of RFC-4180 quoting, which is not a formula guard: Excel and Sheets strip the
 * quotes BEFORE evaluating a cell whose first character is `=`, `+`, `-`, `@`,
 * tab, or CR, so quoting alone shipped live formulas out of family-typed free
 * text (#1307).
 *
 * Behaviour is deliberately identical to the backend helper, including the
 * exemption for plain signed decimals — a bare number cannot invoke a function
 * or a DDE call, and guarding it would corrupt the numeric columns staff sort
 * on. Keep the two in step: an escaper that exists twice is an escaper that
 * gets fixed once.
 */
export function csvCell(v: unknown): string {
  if (v === null || v === undefined) return '';
  let s = String(v);
  if (s === '') return '';
  if (/^[=+\-@\t\r]/.test(s) && !/^[-+]?\d+(?:\.\d+)?$/.test(s)) s = `'${s}`;
  if (/[",\n\r]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

export default csvCell;
